import React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { connect } from "react-redux";
import Header from "../components/Header";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import Utilities from "../classes/Utilities";
import Analytics from "../classes/Analytics";
import { IAppState } from "../state/interfaces";
import { IVehicle, IViolationList, ICoverageConfig, IQuoteApiClient, ILOBApiClient, IPaths } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import FullQuoteActions from "../state/fullQuoteActions";
import BravoApiClient from '../classes/BravoApiClient';
import ReactLoading from 'react-loading';


interface IState extends IQuoteStepState {
    quoteUid: string
}

export interface IProps extends RouteComponentProps {
    quoteUid: string,
    vehicles: Array<IVehicle>,
    fillQuote: (quoteUid: string) => Promise<any>,
    fillExternalQuote: (update: any) => Promise<any>,
    updateViolationList: (update: any) => Promise<any>,
    selectCoverageConfig: (coverageConfig: ICoverageConfig) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths,
    stateCode: string | null;
}

class AgentLandingQuote extends React.Component<IProps, IState>
{
    componentDidMount() {
        this.setState({ updatingStore: true }, () => {
            this.props.fillQuote(this.props.quoteUid)
                .then((result) => {
                    //Analytics.onPageRouteChanged(
                    //    result.quoteId?.toString() ?? NO_QUOTE_LABEL,
                    //    "",
                    //    this.props.location.pathname
                    //);
                    return result;
                }, () => { this.setState({ ...this.state, updatingStore: false }); })
                .then((result) => {
                    const rtrQuoteId = parseInt(result.data?.rtrQuoteId, 10);
                    if (rtrQuoteId) {
                        const fqApiClient = new BravoApiClient(result.data.stateCode);
                        fqApiClient.getQuote(rtrQuoteId)
                            .then((fqResponse) => {
                                fqResponse.data.rtrQuoteId = rtrQuoteId;
                                this.props.fillExternalQuote({ quote: fqResponse.data })
                                    .then(() => {
                                        fqApiClient.getViolationList(result.data.stateCode)
                                            .then((violResponse) => {
                                                this.props.updateViolationList(violResponse.data)
                                                    .then(() => {
                                                        this.props.quoteApiClient.getCoverageConfigs(this.props.quoteUid)
                                                            .then((covResponse) => {
                                                                this.props.selectCoverageConfig(covResponse.data[0])
                                                                    .then(() => {
                                                                        this.props.history.push(this.props.PATHS.QUICK);
                                                                        this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_YOUR_HOME, ""));
                                                                    }, () => { this.setState({ ...this.state, updatingStore: false }); })
                                                            }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                                    }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                            }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                    }, () => { this.setState({ ...this.state, updatingStore: false }); });
                            }, () => { this.setState({ ...this.state, updatingStore: false }); });
                    }
                    else {
                        this.props.history.replace(this.props.PATHS.QUICK);
                    }
                }, () => { this.setState({ ...this.state, updatingStore: false }); });
        });
    }

    render() {
        return (
            <div>
                <Header />
                <div className="quote-step-body">
                    <div className="quote-step-container" style={{ maxWidth: "100em", width: "100%" }}>
                        <div className="card qContainer" style={{ padding: "2%" }}>
                            <div className="card-body">
                                <div className="titleArea"><h5>QUOTE LOADING...</h5></div>
                                <div className={"w-100 loading-indicator"}>
                                    <ReactLoading type={"spin"} color={"#34B629"} height={'40px'} width={'40px'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    var quoteUid = !ownProps.match.params["quoteUid"]
        ? null
        : ownProps.match.params["quoteUid"];

    return {
        quoteUid: quoteUid,
        vehicles: state.vehicles,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(new BravoApiClient(''));

    return {
        fillQuote: (quoteUid) => dispatch(quoteActions.agentLandingQuote(quoteUid)),
        fillExternalQuote: (update) => dispatch(fullQuoteActions.fillExternalQuote(update.quote)),
        updateViolationList: (update: IViolationList) => dispatch(quoteActions.updateViolatioList(update)),
        selectCoverageConfig: (update: ICoverageConfig) => dispatch(quoteActions.selectCoverageConfig(update))
    };
};

export default connect(mapProps, mapDispatch)(AgentLandingQuote);